import getStore from '../store/store';

/**
 * Selector for user emails of all the added shared folder users
 */
export default function getSharedFolderUserEmails(): string[] {
    return getStore().sharedFolderUserEmails;
}
